import apiClient from './apiClient';

// Areas API
export const areasAPI = {
  getAll: () => apiClient.get('/areas/'),
  getById: (id) => apiClient.get(`/areas/${id}/`),
  create: (data) => apiClient.post('/areas/', data),
  update: (id, data) => apiClient.put(`/areas/${id}/`, data),
  partialUpdate: (id, data) => apiClient.patch(`/areas/${id}/`, data),
  delete: (id) => apiClient.delete(`/areas/${id}/`),
  getPersonas: (id) => apiClient.get(`/areas/${id}/personas/`),
  getEstadisticas: (id) => apiClient.get(`/areas/${id}/estadisticas/`),
};

// Negocios API
export const negociosAPI = {
  getAll: () => apiClient.get('/negocios/'),
  getById: (id) => apiClient.get(`/negocios/${id}/`),
  create: (data) => apiClient.post('/negocios/', data),
  update: (id, data) => apiClient.put(`/negocios/${id}/`, data),
  partialUpdate: (id, data) => apiClient.patch(`/negocios/${id}/`, data),
  delete: (id) => apiClient.delete(`/negocios/${id}/`),
};

// Personas API  
export const personasAPI = {
  getAll: (params = {}) => apiClient.get('/personas/', { params }),
  getById: (id) => apiClient.get(`/personas/${id}/`),
  create: (data) => apiClient.post('/personas/', data),
  update: (id, data) => apiClient.put(`/personas/${id}/`, data),
  partialUpdate: (id, data) => apiClient.patch(`/personas/${id}/`, data),
  delete: (id) => apiClient.delete(`/personas/${id}/`),
  getIniciativas: (id, params = {}) => apiClient.get(`/personas/${id}/iniciativas/`, { params }),
  getDedicaciones: (id, params = {}) => apiClient.get(`/personas/${id}/dedicaciones/`, { params }),
  getResumen: (id) => apiClient.get(`/personas/${id}/resumen/`),
  getCurrentUser: () => apiClient.get('/personas/me/'),  // Nuevo endpoint
};

// Dedicaciones API
export const dedicacionesAPI = {
  getAll: (params = {}) => apiClient.get('/dedicaciones/', { params }),
  getById: (id) => apiClient.get(`/dedicaciones/${id}/`),
  create: (data) => apiClient.post('/dedicaciones/', data),
  update: (id, data) => apiClient.put(`/dedicaciones/${id}/`, data),
  partialUpdate: (id, data) => apiClient.patch(`/dedicaciones/${id}/`, data),
  delete: (id) => apiClient.delete(`/dedicaciones/${id}/`),
  getByPersona: (personaId, params = {}) => apiClient.get(`/dedicaciones/`, { 
    params: { ...params, persona: personaId } 
  }),
  getByIniciativa: (iniciativaId, params = {}) => apiClient.get(`/dedicaciones/`, { 
    params: { ...params, iniciativa: iniciativaId } 
  }),
  getByDateRange: (fechaInicio, fechaFin, params = {}) => apiClient.get(`/dedicaciones/`, { 
    params: { ...params, fecha_inicio: fechaInicio, fecha_fin: fechaFin } 
  }),
  bulkCreate: (dedicacionesList) => apiClient.post('/dedicaciones/bulk_create/', { dedicaciones: dedicacionesList }),
  bulkUpdate: (dedicacionesList) => apiClient.post('/dedicaciones/bulk_update/', { dedicaciones: dedicacionesList }),
  bulkDelete: (ids) => apiClient.post('/dedicaciones/bulk_delete/', { ids: ids }),
};

// Iniciativas API
export const iniciativasAPI = {
  getAll: (params = {}) => apiClient.get('/iniciativas/resumen_general/', { params }),
  getList: (params = {}) => apiClient.get('/iniciativas/', { params }),
  getProyectosOperacionesDropdown: () => apiClient.get('/iniciativas/proyectos_operaciones_dropdown/'),
  getAllWithPersonas: () => apiClient.get('/iniciativas/resumen_con_personas/', {
    timeout: 60000 // 60 segundos para esta petición específica
  }),
  getTablaDesarrolloNegocio: () => apiClient.get('/iniciativas/tabla_desarrollo_negocio/'),
  getKpisDesarrolloNegocio: () => apiClient.get('/iniciativas/kpis_desarrollo_negocio/'),
  getTablaOperaciones: (params = {}) => apiClient.get('/iniciativas/tabla_operaciones/', { params }),
  getById: (id) => apiClient.get(`/iniciativas/${id}/`),
  create: (data) => apiClient.post('/iniciativas/', data),
  update: (id, data) => apiClient.put(`/iniciativas/${id}/`, data),
  partialUpdate: (id, data) => apiClient.patch(`/iniciativas/${id}/`, data),
  delete: (id) => apiClient.delete(`/iniciativas/${id}/`),
  getPersonas: (id) => apiClient.get(`/iniciativas/${id}/personas/`),
  agregarPersona: (id, data) => apiClient.post(`/iniciativas/${id}/agregar_persona/`, data),
  removerPersona: (id, data) => apiClient.post(`/iniciativas/${id}/remover_persona/`, data),
  eliminarPersona: (id, personaVinculadaId) => apiClient.delete(`/iniciativa-personas/${personaVinculadaId}/`),
  updatePersonaRelacion: (id, personaVinculadaId, data) => apiClient.patch(`/iniciativa-personas/${personaVinculadaId}/`, data),
  getDedicaciones: (id, params = {}) => apiClient.get(`/iniciativas/${id}/dedicaciones/`, { params }),
  getResumen: (id) => apiClient.get(`/iniciativas/${id}/resumen/`),
  
  // Nuevos endpoints para iniciativas genéricas
  getGenericasDisponibles: () => apiClient.get('/iniciativas/genericas_disponibles/'),
  
  // Comentarios endpoints
  getComentarios: (id) => apiClient.get(`/iniciativas/${id}/comentarios/`),
  agregarComentario: (id, data) => apiClient.post(`/iniciativas/${id}/agregar_comentario/`, data),
  actualizarComentario: (id, comentarioId, data) => apiClient.patch(`/iniciativas/${id}/comentarios/${comentarioId}/`, data),
  eliminarComentario: (id, comentarioId) => apiClient.delete(`/iniciativas/${id}/comentarios/${comentarioId}/`),
  
  // Hitos de facturación endpoints
  getHitosFacturacion: (id) => apiClient.get(`/iniciativas/${id}/hitos_facturacion/`),
  agregarHitoFacturacion: (id, data) => apiClient.post(`/iniciativas/${id}/hitos_facturacion/`, data),
  actualizarHitoFacturacion: (hitoId, data) => apiClient.patch(`/hitos-facturacion/${hitoId}/`, data),
  eliminarHitoFacturacion: (hitoId) => apiClient.delete(`/hitos-facturacion/${hitoId}/`),
  
  // Supervisión endpoints
  checkSupervision: (id) => apiClient.get(`/iniciativas/${id}/check_supervision/`),
  marcarSupervision: (id, data) => apiClient.post(`/iniciativas/${id}/marcar_supervision/`, data),
  
  // Enlace propuesta endpoints
  checkEnlacePropuesta: (id) => apiClient.get(`/iniciativas/${id}/check_enlace_propuesta/`),
  guardarEnlacePropuesta: (id, data) => apiClient.post(`/iniciativas/${id}/guardar_enlace_propuesta/`, data),
};

// Iniciativa-Persona API
export const iniciativaPersonaAPI = {
  getAll: (params = {}) => apiClient.get('/iniciativa-personas/', { params }),
  getById: (id) => apiClient.get(`/iniciativa-personas/${id}/`),
  create: (data) => apiClient.post('/iniciativa-personas/', data),
  update: (id, data) => apiClient.put(`/iniciativa-personas/${id}/`, data),
  partialUpdate: (id, data) => apiClient.patch(`/iniciativa-personas/${id}/`, data),
  delete: (id) => apiClient.delete(`/iniciativa-personas/${id}/`),
  activar: (id) => apiClient.post(`/iniciativa-personas/${id}/activar/`),
  desactivar: (id) => apiClient.post(`/iniciativa-personas/${id}/desactivar/`),
};

// Hitos de Facturación API
export const hitosFacturacionAPI = {
  // Obtener todos los hitos con filtros opcionales
  getAll: (params = {}) => apiClient.get('/hitos-facturacion/', { params }),
  
  // Obtener un hito específico por ID
  getById: (id) => apiClient.get(`/hitos-facturacion/${id}/`),
  
  // Crear un nuevo hito
  create: (data) => apiClient.post('/hitos-facturacion/', data),
  
  // Actualizar un hito completo
  update: (id, data) => apiClient.put(`/hitos-facturacion/${id}/`, data),
  
  // Actualizar parcialmente un hito
  partialUpdate: (id, data) => apiClient.patch(`/hitos-facturacion/${id}/`, data),
  
  // Eliminar un hito
  delete: (id) => apiClient.delete(`/hitos-facturacion/${id}/`),
  
  // Obtener KPIs de facturación
  getKPIs: (params = {}) => apiClient.get('/hitos-facturacion/get_kpis/', { params }),

  // Obtener histórico anual de facturación con desgloses
  getHistoricoFacturacion: (params = {}) => apiClient.get('/hitos-facturacion/historico_facturacion/', { params }),

  // Obtener opciones de zona geográfica y país
  getChoices: () => apiClient.get('/hitos-facturacion/choices/'),
  
  // Buscar hitos
  search: (searchTerm, params = {}) => apiClient.get('/hitos-facturacion/', { 
    params: { ...params, search: searchTerm } 
  }),
};

// Objetivos de Facturación Anual API
export const objetivosFacturacionAPI = {
  getAll: () => apiClient.get('/objetivos-facturacion/'),
  update: (id, data) => apiClient.patch(`/objetivos-facturacion/${id}/`, data),
  create: (data) => apiClient.post('/objetivos-facturacion/', data),
};

// Estadísticas API
export const estadisticasAPI = {
  getGenerales: (params = {}) => apiClient.get('/estadisticas/generales/', { params }),
  getMensuales: (params = {}) => apiClient.get('/estadisticas/mensuales/', { params }),
  getPorArea: (params = {}) => apiClient.get('/estadisticas/por_area/', { params }),
  getInnovacionIniciativas: (params = {}) => apiClient.get('/estadisticas/innovacion_iniciativas/', { params }),
};

// Authentication API
export const authAPI = {
  login: (credentials) => apiClient.post('/auth/login/', credentials),
  logout: () => apiClient.post('/auth/logout/'),
  checkStatus: () => apiClient.get('/auth/status/'),
  getCsrfToken: () => apiClient.get('/auth/csrf/'),
};

// Helper functions for common operations
export const apiHelpers = {
  // Format date for API
  formatDate: (date) => {
    if (!date) return null;
    if (typeof date === 'string') return date;
    return date.toISOString().split('T')[0];
  },

  // Get current week dates
  getCurrentWeekDates: () => {
    const now = new Date();
    const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay()));
    const endOfWeek = new Date(now.setDate(now.getDate() - now.getDay() + 6));
    return {
      start: startOfWeek.toISOString().split('T')[0],
      end: endOfWeek.toISOString().split('T')[0],
    };
  },

  // Get current month dates
  getCurrentMonthDates: () => {
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return {
      start: startOfMonth.toISOString().split('T')[0],
      end: endOfMonth.toISOString().split('T')[0],
    };
  },

  // Handle API errors
  handleError: (error) => {
    if (error.response?.data) {
      return error.response.data;
    }
    return { error: error.message || 'Error desconocido' };
  },
};

// Semanas Confirmadas API
export const semanasConfirmadasAPI = {
  // Obtener semanas confirmadas de una persona
  getByPersona: (personaId) => apiClient.get('/semanas-confirmadas/', { 
    params: { persona_id: personaId } 
  }),
  
  // Confirmar una semana
  confirmar: (data) => apiClient.post('/semanas-confirmadas/confirmar/', data),
  
  // Verificar si una semana específica está confirmada
  isWeekConfirmed: async (personaId, fechaInicioSemana) => {
    try {
      const response = await apiClient.get('/semanas-confirmadas/', { 
        params: { persona_id: personaId } 
      });
      const semanasConfirmadas = response.data.results || [];
      
      // Convertir fecha a objeto Date para calcular semana ISO
      const fecha = new Date(fechaInicioSemana);
      const [isoYear, isoWeek] = [fecha.getFullYear(), getISOWeek(fecha)];
      
      return semanasConfirmadas.some(semana => 
        semana.año === isoYear && semana.semana === isoWeek
      );
    } catch (error) {
      console.error('Error verificando semana confirmada:', error);
      return false;
    }
  },
  
  // Obtener todas las week_keys confirmadas para una persona (para compatibilidad con frontend actual)
  getConfirmedWeekKeys: async (personaId) => {
    try {
      const response = await apiClient.get('/semanas-confirmadas/', { 
        params: { persona_id: personaId } 
      });
      const semanasConfirmadas = response.data.results || [];
      return semanasConfirmadas.map(semana => semana.week_key);
    } catch (error) {
      console.error('Error obteniendo week keys confirmadas:', error);
      return [];
    }
  }
};

// Helper function to calculate ISO week number
function getISOWeek(date) {
  const target = new Date(date.valueOf());
  const dayNr = (date.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  const firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
  }
  return 1 + Math.ceil((firstThursday - target) / 604800000);
}

// ---------------------------------------------------------------------------
// Módulo de Control de Pedidos y Presupuesto
// ---------------------------------------------------------------------------

// Partidas API
export const partidasAPI = {
  getAll: (params = {}) => apiClient.get('/partidas/', { params }),
  getById: (id) => apiClient.get(`/partidas/${id}/`),
  create: (data) => apiClient.post('/partidas/', data),
  update: (id, data) => apiClient.put(`/partidas/${id}/`, data),
  partialUpdate: (id, data) => apiClient.patch(`/partidas/${id}/`, data),
  delete: (id) => apiClient.delete(`/partidas/${id}/`),
  // Árbol jerárquico con estadísticas de presupuesto (consumido / previsto)
  getTree: () => apiClient.get('/partidas/arbol/'),
  // Solo partidas hoja (para el selector de formulario de pedido)
  getHojas: () => apiClient.get('/partidas/hojas/'),
  // Partidas de nivel 2 (áreas tecnológicas, para el filtro de tecnología)
  getAreas: () => apiClient.get('/partidas/areas/'),
};

// Pedidos API
export const pedidosAPI = {
  getAll: (params = {}) => apiClient.get('/pedidos/', { params }),
  getById: (id) => apiClient.get(`/pedidos/${id}/`),
  create: (data) => apiClient.post('/pedidos/', data),
  update: (id, data) => apiClient.put(`/pedidos/${id}/`, data),
  partialUpdate: (id, data) => apiClient.patch(`/pedidos/${id}/`, data),
  delete: (id) => apiClient.delete(`/pedidos/${id}/`),
  // Resumen global: total presupuesto, consumido, previsto y desglose por estado
  getEstadisticas: () => apiClient.get('/pedidos/estadisticas/'),
};

// Acciones Desarrollo de Negocio API
export const accionesDNAPI = {
  getAll: (params = {}) => apiClient.get('/acciones-dn/', { params }),
  getById: (id) => apiClient.get(`/acciones-dn/${id}/`),
  create: (data) => apiClient.post('/acciones-dn/', data),
  update: (id, data) => apiClient.put(`/acciones-dn/${id}/`, data),
  partialUpdate: (id, data) => apiClient.patch(`/acciones-dn/${id}/`, data),
  delete: (id) => apiClient.delete(`/acciones-dn/${id}/`),
  getChoices: () => apiClient.get('/acciones-dn/choices/'),
  getComentarios: (id) => apiClient.get(`/acciones-dn/${id}/comentarios/`),
  agregarComentario: (id, data) => apiClient.post(`/acciones-dn/${id}/comentarios/`, data),
  actualizarComentario: (id, comentarioId, data) => apiClient.patch(`/acciones-dn/${id}/comentarios/${comentarioId}/`, data),
  eliminarComentario: (id, comentarioId) => apiClient.delete(`/acciones-dn/${id}/comentarios/${comentarioId}/`),
};

export const notificacionesAPI = {
  getMisNotificaciones: () => apiClient.get('/notificaciones/mis-notificaciones/'),
  getNoLeidasCount: () => apiClient.get('/notificaciones/mis-notificaciones/no-leidas-count/'),
  marcarLeida: (id) => apiClient.post(`/notificaciones/${id}/marcar-leida/`),
  marcarTodasLeidas: () => apiClient.post('/notificaciones/marcar-todas-leidas/'),
};